module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Your Profile")]), _vm._v(" "), _c('div', {
    staticClass: "profile-card"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _vm._v(" "), _c('h5', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "timeline"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suggestions",
    attrs: {
      "id": "sticky-sidebar"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Shops Followed")]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Simi Shapers")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Chris Foodstore")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Olafumi Jewellries")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Trish Hairs")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Nina Organics")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" 62 shops")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion ion-android-person-add"
  }), _vm._v(" 1,500 friends")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-news-feed"
  }, [_c('li', [_c('i', {
    staticClass: "icon ion-ios-paper"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tradefair Newsfeed")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-shopping-cart"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shops Following")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-ios-people-outline"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Friends")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-chatboxes"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Discussions / Messages")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-images"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-bell"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("No6ifications")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06ac0dee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/rightsidebar.vue
// module id = 366
// module chunks = 0